import { LocationType } from '../../../components/locationCard/LocationCard';
import { AnalyticsProject } from '../interfaces/analyticsProject';

export function convertToAnalyticsProject(project: ProjectData) {
  const analyticsProject: AnalyticsProject = {
    id: project?.id,
    title: project?.name,
    propertyType: project?.propertyType,
    developer: project?.developer,
    location: {
      zone: [],
      district: [],
      road: [],
    },
    transportations: [],
    priceTypes: {
      starting_price: project?.priceTypes?.starting_price,
      level: project?.priceTypes?.level,
    },
  };

  project?.location?.zone.map((zone) => {
    analyticsProject.location.zone.push({
      value: zone.value,
      label: zone.label,
      link: zone.link,
      parent: zone.parent
        ? {
            value: zone.parent?.value,
            label: zone.parent?.label,
            link: zone.parent?.link,
          }
        : null,
    });
  });

  project?.location?.district.map((district) => {
    analyticsProject.location.district.push({
      value: district.value,
      label: district.label,
      link: district.link,
      parent: district.parent
        ? {
            value: district.parent?.value,
            label: district.parent?.label,
            link: district.parent?.link,
          }
        : null,
    });
  });

  project?.location?.road.map((road) => {
    analyticsProject.location.road.push({
      value: road.value,
      label: road.label,
      link: road.link,
      parent: road.parent
        ? {
            value: road.parent?.value,
            label: road.parent?.label,
            link: road.parent?.link,
          }
        : null,
    });
  });

  project?.transportations?.map((transportation) => {
    analyticsProject.transportations.push({
      label: transportation.label,
      value: transportation.value,
    });
  });

  return analyticsProject;
}

export interface ProjectData {
  id: number;
  name: string;
  propertyType?: string[];
  developer?: string;
  location?: {
    zone: ProjectLocationData[];
    district: ProjectLocationData[];
    road: ProjectLocationData[];
  };
  transportations?: {
    label: string;
    value: string;
  }[];
  priceTypes?: {
    starting_price: string;
    level: {
      value: string;
      label: string;
    };
  };
}

export interface ProjectLocationData {
  value: string;
  label: string;
  link: string;
  parent?: ProjectLocationData;
}

export interface ArticleSearchData {
  index?: number;
  keyword?: string;
  locationName?: string;
  locationType?: LocationType;
  max_price?: number;
  min_price?: number;
  priceSegment?: string;
  project?: string;
  section?: string;
}
